import styled from 'styled-components';

const namespace = 'allie-comments';

interface StyledCommentsContainerProps {
  maxCommentsVisible: number;
}

export const StyledCommentsContainer = styled.section<StyledCommentsContainerProps>`
  width: 100%;

  .${namespace}__new {
    display: flex;
    column-gap: 20px;
    margin-bottom: 32px;
  }

  .${namespace}__container-input {
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    &__comment {
      margin-top: 0;
    }

    &__button {
      margin-top: 12px;
      display: flex;
      justify-content: flex-end;
    }
  }

  .${namespace}__list {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    background-color: var(--allie-color-neutral-10);
    padding: 20px 16px;
    max-height: calc(${(props) => props.maxCommentsVisible} * 78px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--allie-color-neutral-30);
    }
    &::-webkit-scrollbar-thumb {
      background: var(--allie-color-neutral-70);
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: var(--allie-color-neutral-50);
    }
  }

  .${namespace}__list-item {
    display: flex;
    column-gap: 20px;
  }

  .${namespace}__avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  .${namespace}__name {
    font-weight: 600;
  }

  .${namespace}__comment-content {
    flex-grow: 1;
  }

  .${namespace}__title {
    display: flex;
    column-gap: 6px;
    justify-content: space-between;
    margin-bottom: 6px;
  }
`;
